import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CmsNavigationComponent } from '@spartacus/core';
import { CategoryNavigationComponent, CmsComponentData, NavigationService, GenericLinkComponent } from '@spartacus/storefront';
import { NgTemplateOutlet, NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-category-navigation',
    templateUrl: './kn-br-category-navigation.component.html',
    styleUrls: ['./kn-br-category-navigation.component.scss'],
    imports: [NgTemplateOutlet, NgClass, GenericLinkComponent, AsyncPipe]
})
export class KnBrCategoryNavigationComponent extends CategoryNavigationComponent implements OnInit {
  blockedWords = ['Returns', 'Invoices']
  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService,
    protected modalService: NgbModal
  ) {
    super(componentData, service);
  }
  ngOnInit(): void {}

  getMenuSlice(menu) {
    return Math.ceil(menu.length/2)
  }
}
